/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { PriorityAndStageDto } from '../dto';

export const PriorityAndStageMapper = entity<PriorityAndStageDto>({});
